<template>
    <div class="event">
        <template v-if="!removed">
            <div class="labels" v-if="!id">
                <label class="label-text">
                    <span class="new-item-indicator"></span>
                    {{ t('customEvents-event_title_label') }}
                </label>
            </div>

            <div class="event-text">
                <input
                    :id="id ? `event-title-${id}` : 'event-title-new'"
                    :name="id ? `event-title-${id}` : 'event-title-new'"
                    type="text"
                    class="form-control"
                    v-model="textField"
                    :disabled="!canChangeName"
                    :placeholder="t('customEvents-event_title_placeholder')"
                />
                <span class="tooltip" v-if="!canChangeName">
                    {{ t('customEvents-cannot_edit_warning') }}
                </span>
            </div>

            <div class="clear"></div>
            <div class="stats" v-if="id">
                <span>
                    {{ t(registrations === 1 ? 'customEvents-registrations_count' : 'customEvents-registrations_count_plural', [registrations]) }}
                </span>
            </div>
            <div class="clear"></div>
            <div class="event-remove">
                <span @click="remove()">{{ t('customEvents-archive_event') }}</span>
            </div>
        </template>
        <template v-if="removed">
            <div class="remove-notice">
                <span v-html="t('customEvents-remove_notice', [textField])"></span>
                <a href="" class="undo" @click.prevent="undoRemove()"
                    ><div class="far fa-undo"></div>
                    {{ t('customEvents-undo') }}</a
                >
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        status: String,
        title: String,
        registrations: Number,
        used: Number,
        disabled: Boolean,
        id: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            textField: this.title,
            registrationsField: this.registrations,
            idField: this.id,
            state: this.status,
            removed: false,
        };
    },
    computed: {
        canChangeName: function () {
            if (this.registrations > 0) {
                return false;
            }
            return true;
        },
    },
    mounted: function () {
        this.$emit("change", this);
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        remove: function () {
            this.removed = true;
            this.$emit("change", this);
        },
        undoRemove: function () {
            this.removed = false;
            this.$emit("change", this);
        },
        save: function () {
            var options = keviApi.getOptions(
                "custom-events/add-event",
                "POST",
                this.getData(),
            );
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.idField = response.body.id;
                    this.setState("saved");
                }
            });
        },
        getData: function () {
            return { title: this.textField };
        },
    },
    watch: {
        registrationsField: function () {
            this.$emit("change", this);
        },
    },
};
</script>
